const asList = (value) => (Array.isArray(value) ? value : []);

export const getManualCloseDefaultStatus = ({ manualCloseStatus, preview } = {}) => {
  const existingStatus = String(manualCloseStatus || "").trim().toUpperCase();
  if (existingStatus) return existingStatus;
  return preview?.replacementRequired === false
    && preview?.currentOutboundMatchesEligibleLines === true
    ? "NOT_REQUIRED"
    : "DONE";
};

export const describeCorrectionPreview = (preview) => {
  const eligible = Boolean(preview?.eligibleForReplacementOutboundCorrection)
    && asList(preview?.blockers).length === 0;
  const replacementNotRequired = preview?.replacementRequired === false
    && preview?.currentOutboundMatchesEligibleLines === true
    && asList(preview?.blockers).length === 0;
  if (replacementNotRequired) {
    return {
      eligible: false,
      replacementNotRequired: true,
      tone: "success",
      statusLabel: "No replacement required",
      message: "Current outbound already matches the eligible PO lines. No replacement outbound is required.",
    };
  }
  if (eligible) {
    return {
      eligible: true,
      replacementNotRequired: false,
      tone: "success",
      statusLabel: "Eligible",
      message: "Correction preview is eligible. Review the proposed replacement state before activation.",
    };
  }
  return {
    eligible: false,
    replacementNotRequired: false,
    tone: "warning",
    statusLabel: "Not eligible",
    message: "Correction preview returned blockers. Activation is not available.",
  };
};
